import { Dispatch, SetStateAction, useRef } from 'react';
import { Button, Card, CardBody, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import CommonCardHeader from '../../../../coreComponents/CommonCardHeader';
import { useTranslation } from 'react-i18next';
import { AssistantExamResponse, ExamFile } from '../../../../types/Exams';
import { formatWithOffset } from '../../../../lib/timeUtils';
import { useEffect, useState } from 'react';
import { Image } from '../../../../coreComponents/Image';
import { UserRole } from '../../../../types/Forms';
import { useAssistantCommentExamMutation } from '../../../../reduxToolkit/reducers/usersSlice';
import { PreviewItem } from '../../../commetFileModal';
import { validateImages } from '../../../../lib/filesUtils';
import { Gallery, Item } from 'react-photoswipe-gallery';
import { PreviewGallery } from '../../../previewGallery/PreviewGallery';

type Props = {
  examData: AssistantExamResponse;
  role: UserRole | null;
  botId: string;
  connectToMeeting: () => void;
  // langSelected: string;
  // setLangSelected: Dispatch<SetStateAction<string>>;
  botLoading: boolean;
  leaveMeeting: () => void;
  handleModalOpen: (
    exam_id: number,
    examComment: string,
    detailsId: number | null,
    existingFiles?: ExamFile[] | null | undefined,
  ) => void;
  previews: PreviewItem[];
  onRemovePreview: (p: PreviewItem) => void;
};
const PassedExam = ({
  examData,
  role,
  botId,
  connectToMeeting,

  botLoading,
  leaveMeeting,
  handleModalOpen,
  previews,
  onRemovePreview,
}: Props) => {
  const { t } = useTranslation();
  const [isDisabled, setIsDisabled] = useState(true);
  const [currentDetailsId, setCurrentDetailsId] = useState<number | null>(null);
  const viewerTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  useEffect(() => {
    if (!examData) return;
    setCurrentDetailsId(examData.details?.id ?? null);
  }, [examData]);

  const handleRemovePreview = (p: PreviewItem) => {
    onRemovePreview(p);
  };

  return (
    <Col sm="12">
      <Card>
        <Col sm="8">
          {' '}
          <CommonCardHeader title={t('courses.exam.passedExam')} />
        </Col>

        <CardBody>
          {' '}
          <Row className="">
            <Col sm="2">
              <Image
                src={
                  examData.lesson.lessonCover
                    ? `${process.env.REACT_APP_BACKEND_STATIC}/coursesPics/${examData.lesson.lessonCover}`
                    : '/assets/images/avtar/default-user.png'
                }
                alt="Lesson photo"
                className="img-fluid"
                width={200}
              />
            </Col>
            <Col sm="10">
              <Row sm="auto">
                <p className="mb-2 me-0 pe-1">
                  {t('exams.examId')}: #{examData.id}
                </p>
              </Row>
              <Row sm="auto">
                <p className="mb-2 me-0 pe-1"> {t('courses.exam.examDate')}:</p>{' '}
                {formatWithOffset(examData.examDate, viewerTz, undefined)}
              </Row>
              <Row sm="auto">
                <p className="mb-2 me-0 pe-1"> {t('courses.exam.examGenerateDate')}:</p>

                {formatWithOffset(examData.createdAt, viewerTz, undefined)}
              </Row>
              <Row sm="auto">
                <div className="d-flex flex-column">
                  <p className="mb-2">
                    {t('bot.googleMeetLink')}
                    <a href={examData.googleMeetLink} target="_blank" rel="noreferrer">
                      {examData.googleMeetLink}
                    </a>
                  </p>
                  {role !== UserRole.STUDENT && (
                    <>
                      <div className="d-flex gap-3">
                        <Button
                          onClick={connectToMeeting}
                          color="primary"
                          disabled={botLoading || botId !== ''}
                        >
                          {t('courses.exam.connectBot')}
                        </Button>
                        <Button onClick={leaveMeeting} color="secondary" outline>
                          {t('courses.exam.disconnectBot')}
                        </Button>
                      </div>
                    </>
                  )}
                </div>
              </Row>
              <Row sm="auto" className="mt-3">
                <div className="w-100 d-flex gap-2 justify-content-start align-items-start py-2 border rounded">
                  <Col sm="6">
                    <p className="mb-2">
                      {t('courses.exam.table.examComment')}:{' '}
                      <span>{examData.details?.comment}</span>
                    </p>{' '}
                    {examData.details?.createdAt && (
                      <div className="d-flex flex-column">
                        {/* <div>
                          <p className="mb-2 me-0 pe-1">
                            {t('courses.exam.commentAddDate')}:{' '}
                            {formatWithOffset(examData.details?.createdAt, viewerTz, undefined)}
                          </p>
                        </div> */}
                        <div>
                          <p className="mb-2 me-0 pe-1">
                            {t('courses.exam.table.updatedAt')}:{' '}
                            {formatWithOffset(examData.details?.updatedAt, viewerTz, undefined)}
                          </p>
                        </div>
                      </div>
                    )}
                    <Button
                      color="info"
                      outline
                      onClick={() =>
                        handleModalOpen(
                          examData.id,
                          examData.details?.comment ?? '',
                          currentDetailsId,
                          examData.details?.files,
                        )
                      }
                    >
                      {examData.details?.comment ? t('global.edit') : t('global.add')}
                    </Button>
                  </Col>
                  <Col sm="6">
                    {!!previews.length && (
                      <Col sm="12">
                        <Col sm="12">
                          <p className="mb-2">{t('leads.screenshot')}:</p>
                        </Col>
                        <Col sm="12">
                          <PreviewGallery items={previews} />
                        </Col>
                      </Col>
                    )}
                  </Col>
                </div>
              </Row>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default PassedExam;
